import React, { useState } from 'react';
import { motion } from 'framer-motion';

const blogPosts = [
  {
    id: 1,
    author: 'Lorem Ipsum',
    date: '09 Aug 2023',
    title: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry!',
    excerpt: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    image: 'assets/images/pic.png',
    authorImage: 'assets/images/pic.png',
    link: '/',
  },
  {
    id: 2,
    author: 'Lorem Ipsum',
    date: '09 Aug 2023',
    title: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry!',
    excerpt: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    image: 'assets/images/pic.png',
    authorImage: 'assets/images/pic.png',
    link: '/',
  },
  {
    id: 3,
    author: 'Lorem Ipsum',
    date: '09 Aug 2023',
    title: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry!',
    excerpt: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    image: 'assets/images/pic.png',
    authorImage: 'assets/images/pic.png',
    link: '/',
  },
  {
    id: 4,
    author: 'Lorem Ipsum',
    date: '09 Aug 2023',
    title: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry!',
    excerpt: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    image: 'assets/images/pic.png',
    authorImage: 'assets/images/pic.png',
    link: '/',
  },
  {
    id: 5,
    author: 'Lorem Ipsum',
    date: '09 Aug 2023',
    title: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry!',
    excerpt: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    image: 'assets/images/pic.png',
    authorImage: 'assets/images/pic.png',
    link: '/',
  },
  {
    id: 6,
    author: 'Lorem Ipsum',
    date: '09 Aug 2023',
    title: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry!',
    excerpt: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    image: 'assets/images/pic.png',
    authorImage: 'assets/images/pic.png',
    link: '/',
  },
  {
    id: 7,
    author: 'Lorem Ipsum',
    date: '09 Aug 2023',
    title: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry!',
    excerpt: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    image: 'assets/images/pic.png',
    authorImage: 'assets/images/pic.png',
    link: '/',
  },
  {
    id: 8,
    author: 'Lorem Ipsum',
    date: '09 Aug 2023',
    title: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry!',
    excerpt: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    image: 'assets/images/pic.png',
    authorImage: 'assets/images/pic.png',
    link: '/',
  },
];

const BlogPost = ({ post }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <motion.div
      className="col-md-3"
      style={{ padding: '10px' }}
      whileHover={{ scale: 1.05 }}
      transition={{ type: 'spring', stiffness: 300 }}
    >
      <div
        className="blog-content"
        style={{
          position: 'relative',
          overflow: 'hidden',
          height: '420px',
          borderRadius: '15px',
          boxShadow: '0 6px 25px rgba(0, 0, 0, 0.15)',
          transition: 'transform 0.3s ease-in-out',
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <img
          src={post.image}
          alt="Blog"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            filter: isHovered ? 'brightness(70%)' : 'brightness(100%)',
            transition: 'filter 0.3s ease-in-out',
          }}
        />
        <motion.div
          style={{
            position: 'absolute',
            bottom: isHovered ? '0' : '-100%',
            left: 0,
            right: 0,
            background: 'linear-gradient(180deg, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0.9) 100%)',
            color: '#fff',
            padding: '25px',
            transition: 'bottom 0.4s ease-in-out',
          }}
          animate={{ y: isHovered ? 0 : 100 }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <img
              src={post.authorImage}
              alt="Author"
              style={{
                width: '45px',
                height: '45px',
                borderRadius: '50%',
                border: '2px solid #FFD700',
              }}
            />
            <div>
              <p style={{ margin: 0, fontWeight: 'bold', fontSize: '16px' }}>{post.author}</p>
              <p style={{ margin: 0, fontSize: '13px', color: '#FFD700' }}>{post.date}</p>
            </div>
          </div>
          <h3 style={{ marginTop: '12px', fontSize: '20px', color: '#FFF' }}>{post.title}</h3>
          <p style={{ fontSize: '14px', color: '#E0E0E0' }}>{post.excerpt}</p>
          <a href={post.link} style={{ color: '#FFD700', fontWeight: 'bold', textDecoration: 'none' }}>
            Read more →
          </a>
        </motion.div>
      </div>
    </motion.div>
  );
};

const BlogList = () => (
  <div className="row g-4">
    {blogPosts.map((post) => (
      <BlogPost key={post.id} post={post} />
    ))}
  </div>
);

export default BlogList;
